import React from 'react';
import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useGetStoreOfficesQuery } from '../../features/storeoffices/storeofficesApiSlice';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem} from '@mui/material';
import { useAddNewSupportUserMutation } from '../../features/supportusers/supportusersApiSlice';
import {useGetAssetMastersQuery} from '../../features/assetmasterApiSlice/assetmasterApiSlice'
import { useGetComplMastersQuery } from '../../features/complmaster/complmasterApiSlice';
import useAuth from '../../features/hooks/useAuth';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';


const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const MOBILE_REGEX = /^[0]?[789]\d{9}$/;

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const Adduserformcont = styled.div`
  display: flex;
  flex-wrap:wrap;
  margin:10px;
`

const LabelInputWrapper = styled.div`
  margin-bottom:25px;
  flex:1 0 30%;
  display: ${(props) => props.disp};
`
const SubHeadingField = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left:10px;
  margin-top: 15px;
  margin-bottom: 10px;
  font-weight: bold;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #5C5891; 
`

const MainRoleCategWrapper = styled.div`
  display: flex;
  margin-bottom:30px;
`
const MainRolesWrapper = styled.div`
  margin-left: 10px;
  display: flex;
`

const Label = styled.label`
  width: 100px;
`
const SubmitButton = styled(CommonButton)`
  height:"40px";
  margin-top:"0px";
  margin-bottom:"0px";
`
const AddStoreWrapper =styled.div`
  margin-left:10px;
`  

const AddSupportUsers = () =>{

  const Auth = useAuth();
  const [addNewSupportUser, {
      isLoading,
      isSuccess,
      isError,
      error
  }] = useAddNewSupportUserMutation();

  const {
    data: assetmasters,
    // isLoading,
    // isSuccess,
    // isError,
    // error
  } = useGetAssetMastersQuery('assetmasterlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  const {complmaster} = useGetComplMastersQuery("complList", {
    selectFromResult: ({ data }) => ({
      complmaster: data?.entities
    }),
  })

  const userRef = useRef();
  const errRef = useRef();
  const initialUserState = {
    supportUser:true,
    name:{firstName:"", middleName:"", lastName:""},
    email:"",
    password: "",
    mobileNo:"",
    roles:[], 
    store:"",
    assetCategories:[],
    complaintCategories:[],
    assignedComplaint:[], 
    available:true,
    disabled:false
  }
  
  const [assetMasterData, setAssetMasterData] = useState([]);
  const [complMasterData, setComplMasterData] = useState([]);

  const [storeOffices, setStoreOffices] = useState([]);
  const [users, setUsers] = useState(initialUserState);
  const [value, setValue] = useState({})


  const [validFirstName, setValidFirstName] = useState(false);
  const [firstNameFocus, setFirstNameFocus] = useState(false);

  const [validMiddleName, setValidMiddleName] = useState(false);
  const [middleNameFocus, setMiddleNameFocus] = useState(false);

  const [validLastName, setValidLastName] = useState(false);
  const [lastNameFocus, setLastNameFocus] = useState(false);

  const [validEmail, setValidEmail] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);

  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [validMobile, setValidMobile] = useState(false);
  const [mobileFocus, setMobileFocus] = useState(false);

  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);

  const rolesMAinArray = ["SupportAdmin", "Supervisor", "SupportStaff"];
  const rolesData = () =>{
    let rolesArray = [];
    if(Auth.supportuser && Auth?.roles?.includes("SupportAdmin")){
      rolesArray = [...rolesMAinArray].filter(x => x !== "SupportAdmin");
      return rolesArray;
    }
    if(Auth?.roles?.main.includes("Admin")){
      rolesArray = [...rolesMAinArray];
      return rolesArray;
    }
  }

  useEffect(() =>{
    let tempdata = assetmasters? Object.values(assetmasters?.entities):[];
    setAssetMasterData(tempdata);
    },[assetmasters])

  useEffect(() =>{
    let tempdata = complmaster? Object.values(complmaster):[];
    setComplMasterData(tempdata);
    },[complmaster])

   

  useEffect(() => {
      userRef.current.focus();
  }, [])

  useEffect(() => {
      setValidFirstName(USER_REGEX.test(users.name.firstName));
      setValidMiddleName(USER_REGEX.test(users.name.middleName));
      setValidLastName(USER_REGEX.test(users.name.lastName));
  }, [users.name.firstName, users.name.middleName, users.name.lastName])

  useEffect(() => {
      setValidEmail(EMAIL_REGEX.test(users.email));        
  }, [users.email])

  useEffect(() => {
      setValidPwd(PWD_REGEX.test(users.password));
      setValidMatch(users?.password === value?.confirmpassword);
  }, [users?.password, value?.confirmpassword])

  useEffect(() => {
      setValidMobile(MOBILE_REGEX.test(users.mobileNo));        
  }, [users.mobileNo])
    
  const onChangeuserform = (event, newValue, name) => {
    let tempUser = { ...users }
    let tempValue = {...value}
    if(["firstName","middleName","lastName"].includes(event.target.name)){
      tempUser.name ={...tempUser.name, [event.target.name]:event.target.value}
      setUsers(tempUser);
    }

    if(["email","password","mobileNo","roles"].includes(event.target.name)){
      tempUser = {...tempUser, [event.target.name]:event.target.value};
      setUsers(tempUser);
    }

    if(["roles", "store", "assetCategories", "complaintCategories"].includes(name)){
      tempUser = {...tempUser, [name]:newValue};
      setUsers(tempUser);
    }
    
    if(event.target.name === "confirmpassword"){
      tempValue = {...tempValue,[event.target.name]:event.target.value };
      setValue(tempValue);
    }
  }                    
    
  const onClickFormSubmit = async (e) =>{
    console.log("Entered1")
    e.preventDefault();
    // if button enabled with JS hack
    const v1 = EMAIL_REGEX.test(users.email)
    const v2 = PWD_REGEX.test(users.password);
    console.log("Entered2")
    if (!v1 || !v2) {
          setErrMsg("Invalid Entry");
          return;
    }
    console.log("Entered3")
    try{     
    const res = await addNewSupportUser(users);
    console.log(res)
    if(res?.error?.originalStatus === 409){
      setErrMsg("Email Conflict");
      return alert("Email Id Already Exists.");
    }
    console.log(res?.data?.createdId?.length)
    if(res?.data?.createdId?.length){
      alert(`User: ${users.name.firstName}, with email: ${users.email} and role: ${users.roles} created successfully `)
    } 
    setUsers(initialUserState);
    setValue({});
    setErrMsg('');
    } catch(err){
        console.log(err)
    }
  }

  // console.log(validFirstName,validMiddleName, validLastName, validEmail, validPwd, validMatch, validMobile)

  // console.log(firstNameFocus, middleNameFocus, lastNameFocus, emailFocus, pwdFocus, matchFocus, mobileFocus)



  const {storeoffices}= useGetStoreOfficesQuery("storeoffices", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  })

  useEffect(()=>{
    if(storeoffices){
        setStoreOffices(Object.values(storeoffices))
    }
  },[storeoffices])
  
    return (
        <>
        <HeadingWrap>
          <Span>Add New Support User</Span>
        </HeadingWrap>

        <form onSubmit={(e)=>onClickFormSubmit(e)}>
        
        <Adduserformcont>
            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='firstName'
                onChange={(event, newValue) => onChangeuserform(event, newValue)}
                label="First Name"
                value={users.name.firstName}
                variant="outlined"
                onFocus={() => setFirstNameFocus(true)}
                onBlur={() => setFirstNameFocus(false)}
                sx={{backgroundColor:"white"}}
              />      
              { firstNameFocus && !validFirstName ? <div>Please Enter Valid First Name</div>:null}
               
            </LabelInputWrapper>
       
            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='middleName'
                onChange={(event, newValue) => onChangeuserform(event, newValue)}
                label="Middle Name"
                value={users.name.middleName}
                variant="outlined"
                onFocus={() => setMiddleNameFocus(true)}
                onBlur={() => setMiddleNameFocus(false)}
                sx={{backgroundColor:"white"}}
                />    
              {middleNameFocus && !validMiddleName ? <div>Please Enter Valid Middle Name</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='lastName'
                onChange={(event, newValue) => onChangeuserform(event, newValue)}
                label="Last Name"
                value={users.name.lastName}
                variant="outlined"
                onFocus={() => setLastNameFocus(true)}
                onBlur={() => setLastNameFocus(false)}
                sx={{backgroundColor:"white"}}
              />
              {lastNameFocus && !validLastName ? <div>Please Enter Valid Last Name</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='email'
                onChange={(event, newValue) => onChangeuserform(event, newValue)}
                label="Email"
                value={users.email}
                variant="outlined"
                onFocus={() => setEmailFocus(true)}
                onBlur={() => setEmailFocus(false)}
                sx={{backgroundColor:"white"}}
              />
              {emailFocus && !validEmail ? <span>Email Error Message</span>: null}
           </LabelInputWrapper>       

            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='password'
                type='password'
                onChange={(event, newValue) => onChangeuserform(event, newValue)}
                label="Password"
                value={users.password}
                variant="outlined"
                onFocus={() => setPwdFocus(true)}
                onBlur={() => setPwdFocus(false)}
                sx={{backgroundColor:"white"}}
                />               
                {pwdFocus && !validPwd ?<div>Password Error Message</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
            <TextField
              id="outlined-basic"
              size='small'
              ref={userRef}
              name='confirmpassword'
              type='password'
              onChange={(event, newValue) => onChangeuserform(event, newValue)}
              label="Confirm Password"
              value={value? value.confirmpassword:null}
              variant="outlined"
              onFocus={() => setMatchFocus(true)}
              onBlur={() => setMatchFocus(false)}
              sx={{backgroundColor:"white"}}
              />
              {matchFocus && !validMatch? <div>Password Error Message</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='mobileNo'
                type='text'
                onChange={(event, newValue) => onChangeuserform(event, newValue)}
                label="Enter Mobile Number"
                value={users.mobileNo}
                variant="outlined"
                onFocus={() => setMobileFocus(true)}
                onBlur={() => setMobileFocus(false)}
                sx={{backgroundColor:"white"}}
                />             
              {mobileFocus && !validMobile ? <div>Enter Valid Mobile Number</div>: null}
            </LabelInputWrapper>              
        </Adduserformcont>
        <AddStoreWrapper>
          <LabelInputWrapper>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              size='small'
              value={users.store}
              onChange={(event, newValue) => onChangeuserform(event, newValue, `store`)}
              options={storeOffices?.map(x => x.storeoffice)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{ width: "20%", backgroundColor:"white" }}
              renderInput={(params) => <TextField {...params} label={"Select Store Office"} />}
            />
          </LabelInputWrapper>
        </AddStoreWrapper>

      <SubHeadingField>Roles/Categories</SubHeadingField>
      <MainRoleCategWrapper>
      <MainRolesWrapper>
        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          size='small'
          onChange={(event, newValue) => onChangeuserform(event, newValue, "roles")}
          value={users.roles}
          options={rolesData()}
          disableCloseOnSelect
          getOptionLabel={(option) => option}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
          {option}
          </li>
          )}
          renderInput={(params) => (
          <TextField {...params} label="Select Roles" placeholder="Roles" />          
          )}
          sx={{ minWidth: "300px", backgroundColor:"white" }}
        />     
      </MainRolesWrapper>
        {users?.roles?.includes("SupportStaff") && <>
        <MainRolesWrapper>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            size='small'
            onChange={(event, newValue) => onChangeuserform(event, newValue, "assetCategories")}
            value={users?.assetCategories}
            options={assetMasterData? Object.values(assetMasterData).map(x => x.Category):[]}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
            {option}
            </li>
            )}
            renderInput={(params) => (
            <TextField {...params} label="Select Asset Categories" placeholder="Asset Categories" />          
            )}
            sx={{ minWidth: "300px", backgroundColor:"white" }}
          />      
        </MainRolesWrapper>

      
      <MainRolesWrapper>
      <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            size='small'
            onChange={(event, newValue) => onChangeuserform(event, newValue, "complaintCategories")}
            value={users?.complaintCategories}
            options={
               (complMasterData?.filter(x => x?.ApplAssetCateg?.some(item => users?.assetCategories?.includes(item)))).map(x=>x.Category)
            }
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
            {option}
            </li>
            )}
            renderInput={(params) => (
            <TextField {...params} label="Select Complaint Categories" placeholder="Complaint Categories" />          
            )}
            sx={{ minWidth: "300px", backgroundColor:"white" }}
          />      
        </MainRolesWrapper>
        </>}
        </MainRoleCategWrapper>
        <SubmitButton type='submit' disabled={!validFirstName || !validMiddleName || !validLastName || !validEmail ||  !validPwd || !validMatch || !validMobile  ? true: false}>Submit</SubmitButton>            
        <span>{errMsg}</span>
        </form>
      
        </>
      )
}
export default AddSupportUsers;